<h2 mat-dialog-title *ngIf="!isConfirmationMode">Generated Guidance</h2>
<h2 mat-dialog-title *ngIf="isConfirmationMode">LLM Data Disclosure Notice</h2>

<mat-dialog-content *ngIf="isConfirmationMode">
  <p>You are about to send the following information to an external LLM API. This may include sensitive configuration data.</p>

  <button mat-button (click)="showMore = !showMore">{{ showMore ? 'Hide Details' : 'See More' }}</button>

  <div *ngIf="showMore" style="margin-top: 10px;">
    <ul>
      <li><b>Deployment Type:</b> {{ data.input.deploymentType }}</li>
      <li><b>Primary OS:</b> {{ data.input.primaryOS }}</li>
      <li><b>Identity Management Product:</b> {{ data.input.idMgmtProduct }}</li>
      <li><b>Primary Firewall Product:</b> {{ data.input.primaryFirewallProd }}</li>
      <li><b>Configuration Management Product:</b> {{ data.input.primaryConfigMgmtProduct }}</li>
      <li><b>Development Language:</b> {{ data.input.primaryDevLang }}</li>
      <li><b>Security Tools:</b> {{ data.input.securityToolsDeployed }}</li>
      <li><b>Other Technologies:</b> {{ data.input.otherKeyTech }}, {{ data.input.otherKeyTech2 }}, {{ data.input.otherKeyTech3 }}</li>
    </ul>
  </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="!isConfirmationMode">
  <div class="ql-editor" [innerHTML]="data.guidance | sanitizeHtml"></div>
</mat-dialog-content>

<mat-dialog-actions align="end" *ngIf="isConfirmationMode">
  <button mat-raised-button color="primary" style="background: orange; color: white;" (click)="dialogRef.close('confirm')">Confirm</button>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
</mat-dialog-actions>

<mat-dialog-actions align="end" *ngIf="!isConfirmationMode">
  <button mat-raised-button color="primary" style="background: orange; color: white;" (click)="saveToWorkstream()">Save to Workstream</button>
  <button mat-button (click)="dialogRef.close()">Cancel</button>
</mat-dialog-actions>
